import { render, staticRenderFns } from "./howItWorks.vue?vue&type=template&id=4590ab5f&scoped=true"
import script from "./howItWorks.vue?vue&type=script&lang=js"
export * from "./howItWorks.vue?vue&type=script&lang=js"
import style0 from "./howItWorks.vue?vue&type=style&index=0&id=4590ab5f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4590ab5f",
  null
  
)

export default component.exports